module.exports = __webpack_public_path__ + "img/cart.95796f0b.svg";